<script>
import { employeeSideBar } from "@/assets/static.js";
export default {
  name: "SideBar",
  components: {},
  data: () => ({
    drawer: false,
    linksList: employeeSideBar,
    clicked: false,
    indexClick: 0,
  }),
  methods: {
    clickedItem(action) {
      this.clicked = true;
      this.indexClick = action;
      console.log(action);
    },
  },
};
</script>
<style>
@import "@/assets/css/navStyle.css";
</style>
<template>
  <v-navigation-drawer
    color="prime"
    app
    location="right"
    id="sideBar"
    class="sideBar"
    height="100vh"
    dark
  >
    <v-sheet class="transparent d-none d-md-flex w-sm-50" width="20vw">
      <v-card
        elevation="0"
        rounded="0"
        width="5vw"
        height="65px"
        class="d-flex justify-center align-center client_name blue_bg"
      >
        <h2>HR</h2>
      </v-card>
      <v-sheet
        width="13vw"
        class="d-flex justify-space-between algin-center blue_bg"
      >
        <v-card
          class="transparent d-flex align-center justify-end"
          width="60%"
          elevation="0"
          rounded="0"
        >
          <p class="ma-0 text-left pa-0 logo_text">
            Welcome Back! <br />
            Infinity Sky Light
          </p>
        </v-card>
        <v-card
          class="transparent d-flex align-center justify-center"
          width="40%"
          elevation="0"
          rounded="0"
        >
          <v-avatar color="white" size="40"></v-avatar>
        </v-card>
        <v-divider class="orange"></v-divider>
      </v-sheet>
    </v-sheet>

    <v-list nav dense class="py-md-0 py-14 px-0">
      <router-link
        v-for="(item, index) in linksList"
        :key="index"
        :to="item.link"
      >
        <v-list-item class="d-flex align-center justify-center pa-0">
          <v-list-item-icon class="py-8 ma-0">
            <v-sheet
              class="transparent d-flex align-center justify-center"
              height="100%"
              width="5vw"
            >
              <v-icon
                :color="clicked && indexClick == item.id ? 'orange' : ''"
                :style="
                  clicked && indexClick == item.id
                    ? 'text-decoration: orange  underline;'
                    : ''
                "
                >{{ item.icon }}</v-icon
              >
            </v-sheet>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title
              @click="tab = index"
              :style="{
                color: clicked && indexClick == item.id ? 'orange' : '',
              }"
              >{{ $t(item.title) }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item> -->
        <!-- <v-sheet height="500" width="100px">
            <v-calendar
              ref="calendar"
              :now="today"
              :value="today"
              :events="events"
              color="prime"
              type="week"
              size="40"
            ></v-calendar>
          </v-sheet> -->
        <!-- </v-list-item> -->
      </router-link>
    </v-list>
  </v-navigation-drawer>
</template>
